export enum MENU_ITEM_ID {
	None = 'None',
	Hotkeys = 'Hotkeys',
	PlaybackRate = 'PlaybackRate',
	PlaybackSource = 'PlaybackSource',
}

export interface IPlayerSettingsMenu {
	id: MENU_ITEM_ID;
	icon?: string;
	label: string;
	content?: string;
	hasSubmenu?: boolean;
}
